import BottomControls from './BottomControls'

export default BottomControls
